let API_URL

if (process.env.NODE_ENV === 'production') {
  // Same-origin: callers build URLs as `${API_URL}/path/`, so this must be ''
  // (a '/' would produce '//path/', which browsers treat as host "path").
  API_URL = ''
} else {
  API_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8003'
}

export { API_URL }
